import * as _ from "lodash";
import Vue from "vue";
import { ModelType } from "~/enums/modelType";
import { ObjectModelPropertyRootType } from "~/enums/objectModelPropertyType";
import { ObjectModelRecordHolderType } from "~/enums/objectModelRecordHolderType";
import { ObjectModelTriggerType } from "~/enums/objectModelTriggerType";
import { ObjectHelper } from "~/helpers/objectHelper";
import ObjectModelTriggerContainer from "~/mixins/objectModelTriggerContainer";
import { DatetimeMode } from "~/models/datetimeMode";
import ErrorHandler from "~/models/errorHandling/errorHandler";
import ObjectModelPropertyDefinition from "~/models/objectModelProperties/objectModelPropertyDefinition";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import { BuilderArea } from "../../formability/object_model_builder/enums/builder-area";
import routes from "../../formability/object_model_builder/routes/routes";
import { ObjectModelActionType } from "../enums/objectModelActionType";
import { ObjectModelRelationType } from "../enums/objectModelRelationType";
import { InstanceHelper } from "../helpers/instanceHelper";
import { AttributeMetadataInterface } from "../interfaces/attributeMetadataInterface";
import IRootBuilderModel from "../interfaces/builderModelInterfaces";
import { Hash } from "../interfaces/hashInterfaces";
import { IObjectModel, IObjectModelPermissionConstructorOptionsWCheck, IPermittablesContext, ObjectModelPermissionPermittableType } from "../interfaces/objectModelInterfaces";
import IRepo from "../interfaces/repo";
import ObjectModelActionContainer from "../mixins/objectModelActionContainer";
import ObjectModelPropertyContainer from "../mixins/objectModelPropertyContainer";
import ObjectModelRelationContainer from "../mixins/objectModelRelationContainer";
import Validatable from "../mixins/validatable";
import ObjectModelProvider from "../providers/objectModelProvider";
import PublishedObjectModelProvider from "../providers/publishedObjectModelProvider";
import ElementHandler from "../services/elementHandler";
import { IPeekerOptions } from "../services/peeker";
import Repo from "../state/modules/repo";
import store from "../state/store";
import DashboardConditionalLinkedDetailView from "./dashboardConditionalLinkedDetailView";
import PublishedObjectModelDecorator from './decorators/publishedObjectModelDecorator';
import ModelCollection from "./modelCollection";
import ObjectModelBuilderValidation from "./navigableValidations/objectModelBuilderValidation";
import ObjectModelAction from "./objectModelActions/objectModelAction";
import ObjectModelLimit from "./objectModelLimit";
import LinkedRelationMappedProperty from "./objectModelProperties/linkedRelationMappedProperty";
import ObjectModelProperty from "./objectModelProperties/objectModelProperty";
import ObjectModelRelation from "./objectModelRelations/objectModelRelation";
import Organization from "./organization";
import { RelationType } from "./relationType";
import ObjectModelBuilderModel from "./tracked/objectModelBuilderModel";
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import ObjectModelPermissionContainer from "~/mixins/objectModelPermissionContainer";
import ObjectModelPermissionPermittee from "~/models/objectModelPermissionPermittee";
import ObjectModelPermissionPermitteeContainer from "~/mixins/objectModelPermissionPermitteeContainer";
import ObjectModelPermission from "~/models/objectModelPermissions/objectModelPermission";
import ObjectModelPermissionFactory from "~/models/objectModels/objectModelPermissionFactory";
import {ObjectModelPermissionType} from "~/enums/objectModelPermissionType";
import {ObjectModelPermissionCapabilityType} from "~/enums/objectModelPermissionCapabilityType";
import {Logger} from "~/services/logger";
import PropertySection from "~/models/objectModels/propertySection";
import PropertySectionContainer from "~/mixins/objectModels/propertySectionContainer";
import PropertyElementHandler from "../../formability/object_model_builder/services/propertyElementHandler";
import PropertySectionElementHandler from "../../formability/object_model_builder/services/propertySectionElementHandler";
import {ReferenceNodeType} from '~/enums/referenceNodeType'
import {IImposter, IImposterOptions} from '~/interfaces/imposterInterfaces'
import Imposter from '~/models/imposter'
import {TargetType} from '~/models/conditionalRules/targetType'
import {ComparisonType} from '~/models/conditionalRules/comparisonType'
import {ObjectModelPropertyCapability} from "~/models/objectModelProperties/objectModelPropertyCapability";
import {ReferencePath} from '~/models/referencePaths/referencePath'
import Share from "~/models/share";
import Shareable from "~/mixins/shareable";
import {DocumentType} from "~/enums/documentType";
import {BuiltinPermissionObjectMap, objectModelBuiltinPermission} from "~/enums/objectModelBuiltinPermission";
import {ConditionalRuleBuiltInValueType, ConditionalRuleBuiltInValueTypeName, ObjectModelEntryConditionalRuleBuiltInValueTypes} from "~/models/conditionalRules/conditionalRuleBuiltInValueType";
import IConditionalRuleReferencedControl from "~/models/conditionalRules/referencedControl";

export default class ObjectModel extends Validatable(PropertySectionContainer(ObjectModelPermissionContainer(ObjectModelPermissionPermitteeContainer(ObjectModelTriggerContainer(ObjectModelActionContainer(ObjectModelRelationContainer(ObjectModelPropertyContainer(Shareable(ObjectModelBuilderModel))))))))) implements IRootBuilderModel, IObjectModel {
  rootModel: ObjectModel;
  objectModel = this;
  holder_type: ObjectModelRecordHolderType;
  published_object_model_id?: string;
  organization: Organization;
  application_id: string;
  indexed_property_client_ids: string[];
  indexed_relation_client_ids: string[];
  sorted_relation_client_ids: string[];
  external_id_client_ids: string[];
  inverse_object_model_relations: ModelCollection<ObjectModelRelation> = new ModelCollection<ObjectModelRelation>();
  locked_by: string;
  _publishedRecord: PublishedObjectModelDecorator;
  dashboard_display_enabled: boolean;
  dashboard_name: string;
  dashboard_name_property_client_id: string;
  dashboard_number_property_client_id: string;
  dashboard_expiration_property_client_id: string;
  dashboard_status_property_client_id: string;
  dashboard_linked_detail_view_id: string;
  dashboard_linked_detail_view_title: string;
  dashboard_linked_detail_view_rule_enabled: boolean;
  dashboard_conditional_fallback_linked_detail_view_id: string;
  dashboard_conditional_linked_detail_views: Hash<DashboardConditionalLinkedDetailView> = {}
  dashboard_account_relation_reference_paths: Hash<ReferencePath> = {}
  reference_name: string;
  object_model_linked_forms: Array<{id: string, client_id: string, title: string}>;
  event_bus_name: string;

  object_model_limits: Hash<ObjectModelLimit> = {};

  detail_views: {id: string, title: string}[]

  attributes_metadata: Hash<AttributeMetadataInterface>;

  except = [
    'objectModel',
    'createEmbeddedObject',
    'organization',
    'saveTimer',
    'object_model_properties',
    'object_model_relations',
    'inverse_object_model_relations',
    'object_model_actions',
    'object_model_triggers',
    'object_model_default_actions',
    'object_model_limits',
    'permission_permittees',
    'permissions',
    'shares',
    'object_model_linked_forms',
  ];

  title: string;
  u_at: string;
  c_at: string;
  justApproved: boolean;
  attempted_to_publish: boolean;
  _objectModelPropertyHandler: ElementHandler = new PropertyElementHandler<ObjectModelProperty>(this, ObjectModel, 'object_model_properties', { builderPath: this.builderPath });
  _propertySectionHandler: ElementHandler = new PropertySectionElementHandler<PropertySection>(this, ObjectModel, 'property_sections', { builderPath: this.builderPath });

  get objectModelPropertyHandler(): ElementHandler {
    return this._objectModelPropertyHandler;
  }

  get propertySectionHandler(): ElementHandler {
    return this._propertySectionHandler;
  }

  static repo: IRepo<ObjectModel, ObjectModelProvider> = new Repo<ObjectModel, ObjectModelProvider>('objectModels', ObjectModel, {}, new ObjectModelProvider(ObjectModel, 'object_model', 'object_models'));
  repo: IRepo<this, ObjectModelProvider<this>>;

  static get provider(): ObjectModelProvider {
    return this.repo.provider;
  }
  get provider(): this['repo']['provider'] {
    return this.repo.provider;
  }

  static get displayName(): string {
    return 'Object Model';
  }

  constructor() {
    super();

    this.defineProperty('dashboard_display_enabled', false);
    this.defineProperty('dashboard_name', null);
    this.defineProperty('dashboard_name_property_client_id', null);
    this.defineProperty('dashboard_number_property_client_id', null);
    this.defineProperty('dashboard_expiration_property_client_id', null);
    this.defineProperty('dashboard_status_property_client_id', null);
    this.defineProperty('dashboard_linked_detail_view_id', null);
    this.defineProperty('dashboard_linked_detail_view_rule_enabled', null);
    this.defineProperty('reference_name', null);

    this.defineProperty('holder_type', ObjectModelRecordHolderType.Individual);
  }

  get UNTRACKED_PROPERTIES(): string[] {
    return [
      'is_published',
      'u_at',
      'attributes_metadata',
    ];
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      'object_model_properties': {type: ObjectModelProperty, relationType: RelationType.dictionary},
      'object_model_relations': {type: ObjectModelRelation, relationType: RelationType.dictionary},
      'inverse_object_model_relations': {type: ObjectModelRelation, relationType: RelationType.collection},
      'object_model_default_actions': {type: ObjectModelAction, relationType: RelationType.dictionary},
      'object_model_actions': {type: ObjectModelAction, relationType: RelationType.dictionary},
      'object_model_triggers': {type: ObjectModelTrigger, relationType: RelationType.dictionary},
      'object_model_limits': {type: ObjectModelLimit, relationType: RelationType.dictionary},
      'dashboard_conditional_linked_detail_views': {type: DashboardConditionalLinkedDetailView, relationType: RelationType.dictionary},
      'dashboard_account_relation_reference_paths': {type: ReferencePath, relationType: RelationType.dictionary},
      'permission_permittees': {type: ObjectModelPermissionPermittee, relationType: RelationType.dictionary},
      'permissions': {type: ObjectModelPermission, relationType: RelationType.dictionary},
      'current_user_permissions': {type: ObjectModelPermission, relationType: RelationType.dictionary},
      'property_sections': {type: PropertySection, relationType: RelationType.dictionary},
      'shares': {type: Share, relationType: RelationType.collection},
    };
  }

  createEmbeddedObject = {
    object_model_properties: (parent, json): ObjectModelProperty => {
      return ObjectModelProperty.repo.findOrCreate(json.id, json.client_id)
    },
    object_model_relations: (parent, json): ObjectModelRelation => {
      return ObjectModelRelation.repo.findOrCreate(json.id, json.client_id);
    },
    inverse_object_model_relations: (parent, json): ObjectModelRelation => {
      return ObjectModelRelation.repo.findOrCreate(json.id, json.client_id);
    },
    object_model_default_actions: (parent, json): ObjectModelAction => {
      return new ObjectModelAction();
    },
    object_model_actions: (parent, json): ObjectModelAction => {
      return ObjectModelAction.repo.findOrCreate(json.id, json.client_id);
    },
    object_model_triggers: (parent, json): ObjectModelTrigger => {
      return ObjectModelTrigger.repo.findOrCreate(json.id, json.client_id);
    },
    object_model_limits: (parent, json): ObjectModelLimit => {
      return ObjectModelLimit.repo.findOrCreate(json.id, json.client_id);
    },
    dashboard_conditional_linked_detail_views: (parent, json): DashboardConditionalLinkedDetailView => {
      return DashboardConditionalLinkedDetailView.repo.findOrCreate(json.id, json.client_id);
    },
    dashboard_account_relation_reference_paths: (parent, json): ReferencePath => {
      let referencePath = ReferencePath.repo.find(json.client_id)

      if (!referencePath) {
        referencePath = new ReferencePath(parent, json, {
          nameInParent: 'dashboard_account_relation_reference_paths'
        }).loadFromJson(json)
      }

      return referencePath
    },
    permission_permittees: (parent, json): ObjectModelPermissionPermittee => {
      return new ObjectModelPermissionPermittee(parent, json);
    },
    permissions: (parent, json): ObjectModelPermission => {
      return ObjectModelPermissionFactory.findOrCreate([json.client_id, json.id], parent, json.permission_type, json, { skipCreateCheck: true });
    },
    current_user_permissions: (parent, json): ObjectModelPermission => {
      return this.createEmbeddedObject.permissions(parent, json)
    },
    property_sections: (parent, json): PropertySection => {
      return PropertySection.repo.findOrCreate(json.id, json.client_id);
    },
};

  get rootName() {
    return 'objectModel';
  }

  get collectionKey() {
    return 'object_models';
  }

  get classKey(): string {
    return "objectModel";
  }

  get docType(): DocumentType {
    return DocumentType.objectModel;
  }

  get storeName(): string {
    return `${this.rootName}Store`;
  }


  get requiredObjectModelRelations() {
    return Object.keys(this.object_model_relations).filter(relation_key => this.object_model_relations[relation_key].is_required)
  }

  get optionalObjectModelRelations() {
    return Object.keys(this.object_model_relations).filter(relation_key => this.object_model_relations[relation_key].is_required === false)
  }

  get topLevelProperties(): ObjectModelProperty[] {
    return this.objectModelPropertiesArray.filter((p) => !p.property_section_client_id);
  }

  get propertiesAndPropertySections(): Array<ObjectModelProperty | PropertySection> {
    const items: Array<ObjectModelProperty | PropertySection> = [
      ...this.topLevelProperties,
      ...this.propertySectionsArray,
    ];

    return _.sortBy(items, (item) => item.sort_order);
  }

  get editablePropertiesAndPropertySections(): Array<ObjectModelProperty | PropertySection> {
    const items: Array<ObjectModelProperty | PropertySection> = [
      ...this.topLevelProperties.filter(property => property.can(ObjectModelPropertyCapability.permissionEditable)),
      ...this.propertySectionsArray.filter(section => section.isPermissionEditable),
    ];

    return _.sortBy(items, (item) => item.sort_order);
  }

  get propertyClientIdReferenceFields(): Array<string> {
    return [
      "dashboard_name_property_client_id",
      "dashboard_number_property_client_id",
      "dashboard_expiration_property_client_id",
      "dashboard_status_property_client_id",
    ]
  }

  cleanupPropertyReferences(property: ObjectModelProperty): void {
    const removePropertyReference = (attr: string) => {
      if (this[attr] === property.client_id) {
        this[attr] = null
      }
    }
    this.propertyClientIdReferenceFields.forEach(removePropertyReference)
    this.removePropertyIndex(property);
    this.removePropertyExternalId(property);
  }

  // ******************** VALIDATABLE******************** //
  _validation: ObjectModelBuilderValidation = new ObjectModelBuilderValidation(this);

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      case "dashboard_conditional_fallback_linked_detail_view_id":
        return "You must choose a fallback detail view for the dashboard"
      case "dashboard_name":
        return "Name"
      case "dashboard_number_property_client_id":
        return "Number"
      case "dashboard_expiration_property_client_id":
        return "Expiration Date"
      case "dashboard_status_property_client_id":
        return "Status"
      default:
        return propName;
    }
  }
  // ******************** VALIDATABLE END******************** //

  // ******************** TRACK CHANGES******************** //

  get hasChanged() {
    return this._hasChanged;
  }

  set hasChanged(newVal: boolean) {
    if (newVal) {
      this.queueSendChangesToServer(this.lastPeekerOptions || {area: this.currentBuilderArea(), modelId: this.clientIdOrId});
      if (this.attempted_to_publish) {
        this.validate();
      }
    }
    this._hasChanged = newVal;
  }

  saveToServer(): Promise<any> {
    return store.dispatch(`${this.storeName}/saveToServer`).then(res => {
      this.handleErrorsAndUpdateSaveMessage(res.better_errors)
    }).catch(err => {
      ErrorHandler.autosaveCatch(this, err);
    });
  }

  protected saveChanges(changes: any, peekerOptions: string | IPeekerOptions = {area: this.currentBuilderArea(), modelId: this.clientIdOrId}): void {
    store.commit(`${this.storeName}/saveChanges`, {changes, peekerOptions});
  }

  // ******************** TRACK CHANGES END ******************** //

  get isPublished(): boolean {
    return this.published_object_model_id && Date.now() > Date.parse(this.u_at);
  }

  appendRelation(relationType: ObjectModelRelationType, position: number, relationJson: object = {}): ObjectModelRelation {
    if (position === null || position === undefined) {
      position = this.sorted_relation_client_ids.length;
    }
    return this.createRelation(this, relationType, position, relationJson);
  }

  createRelation(parent: ObjectModel, relationType: ObjectModelRelationType, position: number, json: object = {}): ObjectModelRelation {
    const relation: ObjectModelRelation = this.createEmbeddedObject.object_model_relations(this, json);
    relation.initialize(this.rootModel, parent, relationType, json);
    return this.initializeEmbedded(parent, relation, position, json)
  }

  appendAction(actionType: ObjectModelActionType, position: number, actionJson: object = {}): ObjectModelAction {
    if (position === null || position === undefined) {
      position = this.nextSortOrderFor(ObjectModelAction.rootName);
    }
    return this.createAction(this, actionType, position, actionJson);
  }

  createAction(parent: ObjectModel, actionType: ObjectModelActionType, position: number, actionJson: object = {}): ObjectModelAction {
    actionJson['sort_order'] = position;
    const action: ObjectModelAction = this.createEmbeddedObject.object_model_actions(this, actionJson);
    action.initialize(this.rootModel, parent, actionType, actionJson);
    return this.initializeEmbedded(parent, action, position, actionJson);
  }

  appendTrigger(triggerType: ObjectModelTriggerType, position: number, triggerJson: object = {}): ObjectModelTrigger {
    if (position === null || position === undefined) {
      position = this.nextSortOrderFor(ObjectModelTrigger.rootName);
    }
    return this.createTrigger(this, triggerType, position, triggerJson);
  }

  createTrigger(parent: ObjectModel, triggerType: ObjectModelTriggerType, position: number, triggerJson: object = {}): ObjectModelTrigger {
    triggerJson['sort_order'] = position;
    const trigger: ObjectModelTrigger = this.createEmbeddedObject.object_model_triggers(this, triggerJson);
    trigger.initialize(this.rootModel, parent, triggerType, triggerJson);
    return this.initializeEmbedded(parent, trigger, position, triggerJson);
  }

  createLimit(parent: ObjectModel, type: number = 0, position: number = 0, limitJson: object = {}): ObjectModelLimit {
    const limit: ObjectModelLimit = this.createEmbeddedObject.object_model_limits(this, limitJson);
    limit.initialize(this.rootModel, parent, type, limitJson);
    return this.initializeEmbedded(parent, limit, position, limitJson);
  }

  createDashboardConditionalLinkedDetailView(parent: ObjectModel, type: number = 0, position: number = 0, conditionalDetailViewJson: object = {}): DashboardConditionalLinkedDetailView {
    const dashboardConditionalLinkedDetailView: DashboardConditionalLinkedDetailView = this.createEmbeddedObject.dashboard_conditional_linked_detail_views(this, conditionalDetailViewJson);
    dashboardConditionalLinkedDetailView.initialize(this.rootModel, parent, type, conditionalDetailViewJson);
    return this.initializeEmbedded(parent, dashboardConditionalLinkedDetailView, position, conditionalDetailViewJson);
  }

  appendPermissionPermittee(props): ObjectModelPermissionPermittee {
    props['sort_order'] = this.nextSortOrderFor(ObjectModelPermissionPermittee.rootName);
    const permittee = new ObjectModelPermissionPermittee(this, props);
    this.trackCreationDeletion(permittee.client_id, null, permittee.asJson(), permittee)
    return permittee;
  }

  createPermission(permittee: ObjectModelPermissionPermittee, permittable: ObjectModelPermissionPermittableType, permissionType: ObjectModelPermissionType, capabilityType: ObjectModelPermissionCapabilityType): ObjectModelPermission {
    const json = {
      permittee_client_id: permittee.client_id,
      permittable_client_id: permittable.client_id,
      permission_type: permissionType,
      capability_type: capabilityType,
    }
    const options: IObjectModelPermissionConstructorOptionsWCheck = { permissionType, json, permittee, permittable }
    return ObjectModelPermissionFactory.create(this, options)?.initialize(this);
  }

  updatePositionsForParent(parent: ObjectModel | ObjectModelProperty, item: ObjectModelRelation | ObjectModelProperty | ObjectModelAction | ObjectModelTrigger | LinkedRelationMappedProperty | ObjectModelLimit | DashboardConditionalLinkedDetailView | ReferencePath, position: number): void {
    if (item instanceof ObjectModelProperty && (parent instanceof ObjectModel || parent instanceof ObjectModelProperty)) {
      this.objectModelPropertyHandler.updateElementPositions(parent, item, position);
    } else if (item instanceof PropertySection) {
      this.propertySectionHandler.updateElementPositions(parent, item, position);
    } else if (item instanceof ObjectModelRelation && parent instanceof ObjectModel) {
      parent.addObjectModelRelation(parent, item, position);
    } else if (item instanceof ObjectModelAction && parent instanceof ObjectModel) {
      this.updateActionPositionsForParent(parent, item, position);
    } else if (item instanceof ObjectModelTrigger && parent instanceof ObjectModel) {
      this.updateTriggerPositionsForParent(parent, item, position);
    }
  }

  get titleOrDefault(): string {
    if (this.title && this.title.length > 0) {
      return this.title;
    } else {
      return "Untitled Object Model";
    }
  }

  // ******************** INDEXABLE ******************** //
  static INDEXABLE_LIMIT: number = 10;// keep in sync with backend counterpart

  get indexedProperties(): ObjectModelProperty[] {
    return this.indexed_property_client_ids.map(id => this.object_model_properties[id]).filter(p => p !== undefined);
  }

  isPropertyIndexed(propertyOrId: ObjectModelProperty | string): boolean {
    if (InstanceHelper.isString(propertyOrId)) {
      return this.indexed_property_client_ids.includes(propertyOrId);
    } else {
      return this.indexed_property_client_ids.includes(propertyOrId.client_id);
    }
  }

  removePropertyIndex(property: ObjectModelProperty): void {
    const index = this.indexed_property_client_ids.indexOf(property.client_id);
    if (index !== -1) {
      this.indexed_property_client_ids = this.indexed_property_client_ids.filter(el => {
        return el !== property.client_id
      })
    }
  }

  get hasReachedPropertyIndexLimit(): boolean {
    return this.indexed_property_client_ids.length >= ObjectModel.INDEXABLE_LIMIT;
  }

  get indexedRelations(): ObjectModelRelation[] {
    return this.indexed_relation_client_ids.map(id => this.object_model_relations[id]).filter(p => p !== undefined);
  }

  isRelationIndexed(relationOrId: ObjectModelRelation | string): boolean {
    if (InstanceHelper.isString(relationOrId)) {
      return this.indexed_relation_client_ids.includes(relationOrId);
    } else {
      return this.indexed_relation_client_ids.includes(relationOrId.client_id);
    }
  }

  removeRelationIndex(relation: ObjectModelRelation): void {
    const index = this.indexed_relation_client_ids.indexOf(relation.client_id);
    if (index !== -1) {
      this.indexed_relation_client_ids = this.indexed_relation_client_ids.filter(el => {
        return el !== relation.client_id;
      });
    }
  }

  get hasReachedRelationIndexLimit(): boolean {
    return this.indexed_relation_client_ids.length >= ObjectModel.INDEXABLE_LIMIT;
  }

  // ******************** INDEXABLE END******************** //


  // ******************** EXTERNAL IDABLE ******************** //
  get externalIdProperties(): ObjectModelProperty[] {
    return this.external_id_client_ids.map(id => this.object_model_properties[id]).filter(p => p !== undefined);
  }

  isPropertyExternalId(propertyOrId: ObjectModelProperty | string): boolean {
    if (InstanceHelper.isString(propertyOrId)) {
      return this.external_id_client_ids.includes(propertyOrId);
    } else {
      return this.external_id_client_ids.includes(propertyOrId.client_id);
    }
  }

  removePropertyExternalId(property: ObjectModelProperty): void {
    const index = this.external_id_client_ids.indexOf(property.client_id);
    if (index !== -1) {
      this.external_id_client_ids = this.external_id_client_ids.filter(el => {
        return el !== property.client_id
      })
    }
  }

 // ******************** EXTERNAL IDABLE END******************** //

  initializeEmbedded<T extends ObjectModelProperty | ObjectModelRelation | ObjectModelAction | ObjectModelTrigger | LinkedRelationMappedProperty | ObjectModelLimit | DashboardConditionalLinkedDetailView | ReferencePath>(parent: ObjectModel | ObjectModelProperty, item: T, position: number, json: object = {}) {
    this.updatePositionsForParent(parent, item, position);
    parent.trackCreationDeletion(item.client_id, null, item.asJson(), item);
    item.addToRepo();
    item.select();

    Vue.set(parent[item.rootName], item.client_id, item);
    const path = this.builderPath(item)
    if (path) {
      this.saveChangesToStore({ modelId: item.closestSelectableId, area: path })
    } else {
      this.saveChangesToStore();
    }
    return item;
  }

  getReferencableControls(): ObjectModelProperty[] {
    return this.objectModelPropertiesArray;
  }

  getReferencedControl(id: string): ObjectModelProperty {
    return ObjectModelProperty.repo.find(id);
  }

  friendlyReferencableControlsName = 'property';

  get builtInValueSectionHeading(): string {
    return 'About Record';
  }

  conditionalRuleBuiltInValueTypes(): ConditionalRuleBuiltInValueType[] {
    return ObjectModelEntryConditionalRuleBuiltInValueTypes;
  }

  builtInValueChoiceComparisonOptions(builtInValueType: ConditionalRuleBuiltInValueType): Hash[] {
    return [];
  }

  conditionalRuleBuiltInValueReferenceName(type: ConditionalRuleBuiltInValueType, referenceId: string): string {
    return null;
  }

  removeObjectModelRelation(relationOrClientId: string | ObjectModelRelation) {
    super.removeObjectModelRelation(relationOrClientId);
    let model;
    let clientId: string;
    if (typeof relationOrClientId === 'string') {
      model = ObjectModelRelation.repo.findBy(r => r.client_id === relationOrClientId);
    } else {
      model = relationOrClientId;
    }
    if (model) {
      clientId = model.id;
    }
    if (clientId) {
      for (let p of this.objectModelPropertiesArray) {
        if (p.linked_relation_client_id === clientId) {
          p.linked_relation_client_id = null;
        }
      }
    }
  }

  get inverseObjectModelRelationsArray(): ObjectModelRelation[] {
    return this.inverse_object_model_relations.all;
  }

  mappableObjectModelRelationsFor(property: ObjectModelProperty) {
    const types: ObjectModelRelationType[] = ObjectModelPropertyDefinition.linkedToRelationTypes(property.property_type)
    const inverseTypes: ObjectModelRelationType[] = ObjectModelPropertyDefinition.linkedToRelationInverseTypes(property.property_type)

    const mappable = this.objectModelRelationsArray.filter(r => types.includes(r.relation_type)).map(e => ({ id: e.id, client_id_inverse: e.client_id, client_id: e.client_id, inverse: false, label_title: e.label_title, inverse_label_title: e.inverse_label_title }))
    const inverseMappable = this.inverse_object_model_relations.all.filter(r => inverseTypes.includes(r.relation_type)).map(e => ({ id: e.id, client_id_inverse: e.client_id + 'inverse', client_id: e.client_id, inverse: true, label_title: e.label_title, inverse_label_title: e.inverse_label_title }))

    return mappable.concat(inverseMappable)
  }

  get allActions(): ObjectModelAction[] {
    return [
      ...this.objectModelDefaultActionsArray,
      ...this.objectModelActionsArray,
    ];
  }

  allActionsOfType(actionType: ObjectModelActionType): ObjectModelAction[] {
    if (actionType === ObjectModelActionType.DefaultAction) {
      return this.objectModelDefaultActionsArray;
    } else {
      return this.objectModelActionsArray.filter(action => action.action_type === actionType)
    }
  }

  objectModelRelationsPermissions() {
    return [...this.objectModelRelationsArray, BuiltinPermissionObjectMap[objectModelBuiltinPermission.ConnectOrSeverRecordHolder]]
  }

  permittablesFor(permissionType: ObjectModelPermissionType, context?: IPermittablesContext): Array<ObjectModelAction | ObjectModelProperty | ObjectModelRelation> {
    switch (permissionType) {
      case ObjectModelPermissionType.Action:
        return context?.actionType !== undefined ? this.allActionsOfType(context.actionType) : this.allActions;
      case ObjectModelPermissionType.Property:
        return context?.propertySection !== undefined ? context.propertySection.properties : this.objectModelPropertiesArray;
      case ObjectModelPermissionType.Relationship:
        //@ts-ignore
        return context?.relationType !== undefined ? this.objectModelRelationsOfType(context.relationType) : this.objectModelRelationsPermissions();
      default:
        Logger.errorOnce('ObjectModel#permittablesFor', `Unexpected permissionType: ${permissionType}`);
        return [];
    }
  }

  get allRelations() {
    const types = [ObjectModelRelationType.OneToOne, ObjectModelRelationType.ManyToOne, ObjectModelRelationType.OneToMany]
    const inverseTypes = [ObjectModelRelationType.OneToOne, ObjectModelRelationType.ManyToOne, ObjectModelRelationType.OneToMany]

    const relations = this.objectModelRelationsArray
      .filter(relation => types.includes(relation.relation_type))
      .map(relation => {
        return {
          id: relation.id,
          client_id_inverse: relation.client_id,
          client_id: relation.client_id,
          inverse: false,
          label_title: relation.label_title,
          inverse_label_title: relation.inverse_label_title,
          object_model_id: relation.object_model_id,
          related_object_model_ids: relation.related_object_model_ids,
        }
      })

    const inverseRelations = this.inverseObjectModelRelationsArray
      .filter(inverseRelation => inverseTypes.includes(inverseRelation.relation_type))
      .map(inverseRelation => {
        return {
          id: inverseRelation.id,
          client_id_inverse: inverseRelation.client_id + 'inverse',
          client_id: inverseRelation.client_id,
          inverse: true,
          label_title: inverseRelation.label_title,
          inverse_label_title: inverseRelation.inverse_label_title,
          object_model_id: inverseRelation.object_model_id,
          related_object_model_ids: inverseRelation.related_object_model_ids,
        }
      })

    return relations.concat(inverseRelations);
  }

  get allRelatedAndInverseRelatedObjectModels(): ObjectModel[] {
   const all = _.flatMap(this.objectModelRelationsArray, rel => rel.related_object_models);
   all.push(...this.inverseObjectModelRelationsArray.map(rel => rel.rootObjectModel));
   return all;
  }

  async fetchObjectModelRelations() {
    await ObjectModel.provider.fetchRelations(this).then(([data]) => {
      if (data.success) {
        // load the relations onto this model
        this.loadFromJson({object_model_relations: data.object_model_relations})

        // load all the related models into the repo
        const allRelatedModels = data.object_model_relations.reduce((agg, relation) => {
          agg.push(...relation.related_object_models)
          return agg
        }, [])
        ObjectModel.repo.addManyFromJson(allRelatedModels)
      }
    })
  }

  get hasInverseRelations(): boolean {
    return Object.keys(this.inverse_object_model_relations).length > 0;
  }

  fetchRelatedObjectModels(skipExisting: boolean = false, context: string = 'relation'): Promise<void> {
    const modelIds = new Set();
    const addId = modelIds.add.bind(modelIds);
    for (const rel of this.objectModelRelationsArray) {
      rel.related_object_model_ids.forEach(addId);
    }
    this.inverseObjectModelRelationsArray.map(relation => relation.object_model_id).forEach(addId);

    if (skipExisting) {
      modelIds.forEach(id => {
        if (ObjectModel.repo.any(om => om.id === id)) modelIds.delete(id);
      });
    }

    if (modelIds.size) {
      return ObjectModel.provider.fetch(Array.from(modelIds), context).then(([data]) => {
        if (data.success) {
          const models = ObjectModel.repo.addManyFromJson(data.object_models);
        }
      });
    } else {
      return Promise.resolve();
    }
  }

  get publishedProvider(): PublishedObjectModelProvider<ObjectModel> {
    return new PublishedObjectModelProvider(ObjectModel, 'published_object_model', 'published_object_models')
  }

  async fetchPublishedRecord(): Promise<any> {
    let response
    if (this.published_object_model_id) {
       response = await this.publishedProvider.fetchOne(this.published_object_model_id)
    } else {
      response = await this.provider.fetchPublished(this)
    }
    const data = response[0]
    if (data.success) {
      const json = data[this.publishedProvider.modelRoot]
      if (json) {
        this.buildPublishedRecord(json)
      }
    } else {
      if (import.meta.env.MODE === 'development') {
        console.warn('Published object model request did not succeed', response)
      }
    }
    return response
  }

  buildPublishedRecord(json: Partial<IObjectModel> = {}): this['_publishedRecord'] {
    Vue.set(this, '_publishedRecord', new PublishedObjectModelDecorator().updateFrom(json))
    return this.publishedRecord
  }

  get actionLinkedForms(){
    return this.objectModelActionsArray.filter(
      x=> x.action_type === ObjectModelActionType.FillForm && !!x.linked_form_title && !!x.linked_form_id)
      .map(x => {return  {title: x.linked_form_title, id: x.linked_form_id} })

  }

  get publishedRecord(): this['_publishedRecord'] {
    return this._publishedRecord
  }

  get publishedObjectModel(): this['publishedRecord'] {
    return this.publishedRecord
  }

  dateProperties(includeTime: boolean = false, includeDerivedFields: boolean = false): ObjectModelProperty[]{
    return this.objectModelPropertiesArray.filter(function(x) {
      if (includeDerivedFields && x.property_type === ObjectModelPropertyRootType.DerivedField) {
        return true
      }

      return (x.property_type === ObjectModelPropertyRootType.DateTime) &&
        (includeTime || x.datetime_mode !== DatetimeMode.Time)
    })
  }

  publishedEquivalent(clientIdOrId: string) {
    return this.publishedRecord?.findObjectModelProperty(clientIdOrId) || this.publishedRecord?.findObjectModelRelation(clientIdOrId)
  }

  get modelType(): ModelType {
    return ModelType.ObjectModel
  }

  get loggedActions(): ObjectModelAction[] {
    let defaultActionsDictionary = this.object_model_default_actions;
    let defaultActions = Object.keys(defaultActionsDictionary).filter(key => defaultActionsDictionary[key].is_logged).map(key => defaultActionsDictionary[key]);
    let actionsDictionary = this.object_model_actions;
    let actions = Object.keys(actionsDictionary).filter(key => actionsDictionary[key].is_logged).map(key => actionsDictionary[key]);
    return defaultActions.concat(actions);
  }

  get objectModelLimitsArray(): ObjectModelLimit[]{
    return ObjectHelper.toArray(this.object_model_limits)
  }

  get dashboardAccountRelationReferencePathsArray(): ReferencePath[] {
    return ObjectHelper.toArray(this.dashboard_account_relation_reference_paths)
  }

  get loggedProperties(): ObjectModelProperty[] {
    let propertiesDictionary = this.object_model_properties;
    return Object.keys(propertiesDictionary).filter(key => propertiesDictionary[key].is_logged).map(key => propertiesDictionary[key]);
  }

  get genericType(): GenericType {
    return ModelType.Object
  }

  sortableArray(prop: string) {
    if (prop === 'object_model_properties' || prop === 'property_sections') {
      // properties and property_sections share the same 'sort order' space
      // and can be interleaved with each other in the builder, default edit page,
      // and maybe more
      let array: Array<ObjectModelProperty | PropertySection>
      array = this.objectModelPropertiesArray.filter((p) => !p.property_section_client_id)
      array = array.concat(this.propertySectionsArray)

      return array
    } else {
      return this.propObjectToArray(prop)
    }
  }

  static groupPropertiesBySection(props: ObjectModelProperty[]): {no_section: ObjectModelProperty[], [section_client_id: string]: ObjectModelProperty[]} {
    const res = {no_section: []};
    for (const prop of props) {
      if (!prop.property_section_client_id) {
        res.no_section.push(prop);
      } else {
        if (!res[prop.property_section_client_id]) {
          res[prop.property_section_client_id] = [];
        }
        res[prop.property_section_client_id].push(prop);
      }
    }
    return res;
  }

  get propertiesGroupedBySection(): ReturnType<typeof ObjectModel.groupPropertiesBySection> {
    return ObjectModel.groupPropertiesBySection(this.objectModelPropertiesArray);
  }

  private builderPath(item) {
    let area: string
    if (item instanceof ObjectModelProperty) {
      area = BuilderArea.properties
    } else if (item instanceof PropertySection) {
      area = BuilderArea.properties
    } else if (item instanceof ObjectModelRelation) {
      area = BuilderArea.relationships
    } else if (item instanceof ObjectModelAction) {
      area = BuilderArea.actions
    } else if (item instanceof ObjectModelTrigger) {
      area = BuilderArea.triggers
    } else {
      Logger.warnOnce('ObjectModel', 'builderPath(item): unknown item type')
      return ''
    }
    return routes.find(r => r.name === area).path + `?selectedId=${item.closestSelectableId}`
  }

  get referenceNodeType(): ReferenceNodeType {
    return ReferenceNodeType.ObjectModel
  }

  imposterFor({ modelType, options }: { modelType: ModelType; options?: IImposterOptions }): IImposter {
    return new Imposter({
      ...ObjectHelper.sliceProperties(this as IObjectModel, 'id', 'genericType', 'modelType'),
      isCollection: o => o.isCollection,
    }, options)
  }

  // ******************** IConditionalRuleReferencedControl ******************** //
  isValidForConditionalLogic: boolean = true

  get referenceNameOrDefault(): string {
    return this.title
  }

  displayConditionType(targetType: TargetType, resetReferenceControl: boolean = false): ComparisonType {
    return ComparisonType.record
  }

  getChoiceComparisonOptions(): any[] {
    return []
  }

  getConditionDateTimeMode(): DatetimeMode {
    return null
  }

  getConditionMaxDateTime(): string {
    return ""
  }

  getConditionMinDateTime(): string {
    return ""
  }

  targetTypes(): TargetType[] {
    return []
  }

  // ******************** IConditionalRuleReferencedControl END******************** //
}
